import React, {useState} from 'react';
import PropTypes from 'prop-types';
import assets from "../../util/assets";
import {CustomInput} from "reactstrap";
import {PricingType} from "../clipstore/broadcaster/library/pricing/type";
import {getAgeGroupDiv} from "../../util/utility";
import ProgressiveImage from "react-progressive-image";
import classnames from "classnames";
import * as _ from "lodash";
import "./index.css";

CommonImageCard.propTypes = {
    content: PropTypes.object.isRequired,
};


CommonImageCard.defaultProps = {
    isDetailPage: false,
    showBroadcasterSection: true,
    isDetailModal: false,
    perVideoPaid: false,
    ppmPaid: false,
    isCheckBox: false,
    hideTitle: false,
    containerClassName: "",
    imgLoadingContainer: "",
    imgContainerClassName: "",
    selectedItems: [],
    pricing:true
}

const videoCount = (props) => {

    let total_videos_length = 0, total_pictures_length = 0;

    if (props.content.hasOwnProperty("total_videos")) {

        total_videos_length = props.content.total_videos;

        if (props.content.hasOwnProperty("total_pictures")) {
            total_pictures_length = props.content.total_pictures;
        }

    } else if (props.content.hasOwnProperty("videos") && Array.isArray(props.content.videos)) {

        total_videos_length = props.content.videos.length;

        if (props.content.hasOwnProperty("pictures") && Array.isArray(props.content.pictures)) {
            total_pictures_length = props.content.videos.length;
        }
    }

    if (total_pictures_length === 0) {
        return total_videos_length;
    } else {
        return total_pictures_length;
    }
}

const disableCheckBox = (props) => {
    const isLengthFive = props.selectedItems.length === 5;
    return (isLengthFive && isElementNotPresentInSelection(props))
}

const isElementNotPresentInSelection = (props) => {
    return _.findIndex(props.selectedItems, function (o) {
        return o.id === props.content.id
    }) === -1
}

const isElementPresentInSelection = (props) => {
    let index = _.findIndex(props.selectedItems, function (o) {
        return o.id === props.content.id
    });

    console.log("isElementPresentInSelection", {
        index,
        selectedItems: props.selectedItems,
        id: props.content.id
    })
    return index !== -1;
}

function CommonImageCard(props) {

    const [onLikeHover, setOnLikeHover] = useState(false);
    const toggle = () => setOnLikeHover(!onLikeHover);

    let imgContainer = classnames("home-container-list-item-img-container-for-without-broadcaster");
    if (props.showBroadcasterSection) {
        imgContainer = classnames("home-container-list-item-img-container", {
            "home-container-list-item-img-container-detail": props.isDetailModal
        })
    } else if (props.imgContainerClassName.length > 0) {
        imgContainer = classnames(props.imgContainerClassName);
    }

    let imgLoadingContainer = classnames("home-container-list-item-img");
    if (props.imgLoadingContainer.length > 0) {
        imgLoadingContainer = classnames(props.imgLoadingContainer);
    }

    return (
        <ProgressiveImage
            delay={1000}
            src={props.content.thumbnail_url}
            placeholder="placeholder"
        >
            {(src, loading) => {
                return loading ? (
                        <img alt="home container thumbnail"
                             className={imgLoadingContainer}
                             src={assets.clipstore.placeholder}/>
                    ) :
                    (
                        <div className={imgContainer}
                             onClick={() => {
                                 !onLikeHover && !props.isCheckBox && props.openDetail(props.content)
                             }}
                             style={{backgroundImage: "url('" + (props.content.type === "image"  ? props.content.url : props.content.thumbnail_url ) + "')"}}>

                            <div className="home-card-custom-input-container">
                                <div className="home-card-custom-input">
                                    {
                                        props.isCheckBox &&
                                        <CustomInput
                                            disabled={disableCheckBox(props)}
                                            type="checkbox"
                                            id={`checkbox-${props.content.id}`}
                                            name={`checkbox-${props.content.id}`}
                                            className="filter-type-checkbox"
                                            onChange={(e) => {
                                                props.selectCard(props.content)
                                            }}
                                        />
                                    }

                                </div>
                            </div>

                            <div className="display-flex-space-between"
                                 style={{alignSelf: 'flex-end', position: 'relative'}}>
                                {
                                    props.content.hasOwnProperty("like") &&
                                    <div className="display-flex home-container-list-item-like-container"
                                         onMouseEnter={toggle}
                                         onMouseLeave={toggle}>
                                        <img width={20} alt={"like"} src={assets.comments.like_with_coin} onClick={() => {
                                            props.clickedOnLike(props.content)
                                        }}/>
                                        {props.content.like.count > 0 && <span
                                            className="home-container-list-item-like">{`${props.content.like.count} Likes`}</span>}
                                        {props.content.like.count > 0 && <span
                                            className="home-container-list-item-like">{`(${props.content.like.formatted})`} </span>}
                                    </div>
                                }
                                <div className="display-flex" style={{alignSelf: 'flex-end', position: 'relative'}}>

                                    <PricingType
                                        content={props.content}
                                        pricingStatus={props.content.hasOwnProperty("pricing_type") ? props.content.pricing_type : props.content.pricing.type}/>


                                    {
                                        (props.content.type === "live" || props.content.type === "available") &&
                                        <div className="home-container-list-item-header">
                                            <div className="live-or-available-rectangle">
                                                {
                                                    props.content.type === "live"
                                                        ?
                                                        <span
                                                            className="live-or-available-text live-bg">{props.content.type}</span>
                                                        :
                                                        <span
                                                            className="live-or-available-text available-bg">{props.content.type}</span>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {
                                        props.content.type === "video"
                                            ?
                                            <div className="home-container-list-video-time-container">
                                                <div
                                                    className="home-container-list-video-time-text">{props.content.hasOwnProperty("duration_formatted") ? props.content.duration_formatted : props.content.durationFormatted}</div>
                                            </div>
                                            :
                                            (
                                                props.content.type === "picture"
                                                    ?
                                                    <div className="home-container-list-video-time-container"
                                                         style={{backgroundColor: 'transparent'}}>
                                                        <img src={assets.clipstore.picture}
                                                             alt="gallery videos" height={16}/>
                                                    </div>
                                                    :
                                                    (props.content.type === "gallery" || props.content.hasOwnProperty("videos")) &&
                                                    <div
                                                        className="home-container-list-gallery-time-container">
                                                        <img src={assets.clipstore.gallery_videos}
                                                             alt="gallery videos" height={16}/>
                                                        <span
                                                            className="home-container-list-gallery-time-text">{videoCount(props)}</span>
                                                    </div>
                                            )
                                    }
                                    <div className="home-container-list-video-time-container"
                                         style={{backgroundColor: 'transparent'}}>
                                        {getAgeGroupDiv(props.content.age_group, "age-group-24")}
                                    </div>
                                </div>
                            </div>

                        </div>
                    )

            }}
        </ProgressiveImage>
    );
}

export default CommonImageCard;